/**
 * O que faz: apresenta os termos básicos de uso público do Gens CRM.
 * Onde usa: rota pública /termos-de-uso e cadastro do aplicativo na Meta.
 * Conexões: React Router e componentes visuais reutilizáveis; não consulta serviços externos.
 * Tabelas: nenhuma.
 * Data: 26/09/2026.
 */
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto max-w-4xl px-4">
        <div className="mb-8">
          <Link
            to="/signup"
            className="mb-4 inline-flex items-center gap-2 font-medium text-blue-600 hover:text-blue-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar ao cadastro
          </Link>

          <div className="mb-2 flex items-center gap-3">
            <div className="rounded-lg bg-blue-100 p-2">
              <FileText className="h-6 w-6 text-blue-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">Termos de Uso</h1>
          </div>
          <p className="text-gray-600">Última atualização: 26/09/2026</p>
        </div>

        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="text-xl">Condições para uso do Gens CRM</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-gray-900">1. Serviço</h2>
              <p className="text-gray-700">
                O Gens CRM é uma plataforma para organização de atendimento, relacionamento com leads e
                gestão operacional de clínicas. O uso do serviço pressupõe a aceitação destes termos e da
                <Link className="ml-1 text-blue-600 underline" to="/politica-de-privacidade">Política de Privacidade</Link>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">2. Conta e acessos</h2>
              <p className="text-gray-700">
                A pessoa responsável pela conta deve manter as informações corretas e controlar os acessos
                da equipe. Cada usuário deve utilizar somente suas próprias credenciais e comunicar qualquer
                uso não autorizado assim que identificá-lo.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">3. Uso permitido</h2>
              <p className="text-gray-700">
                O serviço deve ser usado de forma lícita, respeitando a LGPD, as políticas dos canais
                integrados e os direitos das pessoas cadastradas. É proibido usar a plataforma para envio de
                conteúdo enganoso, ilegal ou não solicitado.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">4. Dados e integrações</h2>
              <p className="text-gray-700">
                A clínica continua responsável pelos dados que registra e pelas autorizações necessárias
                para usar integrações como WhatsApp e Meta. O Gens CRM trata os dados necessários para
                prestar o serviço conforme a Política de Privacidade.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">5. Atualizações e suporte</h2>
              <p className="text-gray-700">
                Podemos atualizar o produto e estes termos para melhorar segurança, operação ou conformidade.
                Alterações relevantes serão comunicadas pelos canais da conta quando aplicável.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">6. Contato</h2>
              <p className="text-gray-700">
                Para dúvidas sobre estes termos, entre em contato pelo e-mail{' '}
                <a className="text-blue-600 underline" href="mailto:contato@genscrm.com.br">contato@genscrm.com.br</a>.
              </p>
            </section>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <Button asChild className="bg-blue-600 hover:bg-blue-700">
            <Link to="/signup">Voltar ao cadastro</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
